var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { defineHiddenProp, observableShallow } from "./common";
var methods = [
    'push',
    'pop',
    'shift',
    'unshift',
    'splice',
    'sort',
    'reverse'
];
var ShallowArray = /** @class */ (function (_super) {
    __extends(ShallowArray, _super);
    function ShallowArray(defaultValue, options) {
        var _this = _super.apply(this, defaultValue) || this;
        defineHiddenProp(_this, '__options', options);
        observableShallow(defaultValue, _this.__options.keys);
        methods.forEach(function (method) {
            var original = _super.prototype[method];
            defineHiddenProp(_this, method, function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                try {
                    var result = original.apply(this, args);
                    var items = void 0;
                    switch (method) {
                        case 'push':
                        case 'unshift':
                            items = args;
                            break;
                        case 'splice':
                            items = args.slice(2);
                            break;
                    }
                    items && observableShallow(items, this.__options.keys);
                    return result;
                }
                catch (error) {
                    throw error;
                }
                finally {
                    // 每次都赋新值触发更新
                    var newArray = new ShallowArray(this, this.__options);
                    this.__options.host[this.__options.hostKey] = newArray;
                }
            });
        });
        return _this;
    }
    return ShallowArray;
}(Array));
export { ShallowArray };
